/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-shadow */
import React, { FC, useState } from 'react'
import * as turf from '@turf/turf'
import Select from 'react-select'
import {
  IonButton, IonCol, IonLabel, IonRow,
} from '@ionic/react'
import { Icon } from '@iconify/react'
import LoadingModal from '../modals/LoadingModal'
import { useRiskRegister } from '../../hooks/risks/useRiskRegister'
import MapControlsV2 from './MapControlsV2'
import RiskRegisterMapV2 from '../maps/apps/RiskRegisterMapV2'
import { AppView } from '../../hooks/risks/types/HookInterfaces'
import AssetProfileV2 from './AssetProfileV2'
import { ObscureBackground, OverlayContainer, SherpaButton } from '../GlobalContainers'
import { CenterForm } from './StyledContainers'
import FormPopup from '../maps/forms/FormPopup'
import { ProvideAddAsset } from '../../hooks/risks/useAddAsset'
import { ListModes, Views } from '../../hooks/risks/helpers/StateReducers'
import { downloader } from './forms/utils/RiskAssessmentCalculations'
import { useWorkspace } from '../../hooks/useWorkspace'
import useApi from '../../hooks/testHooks'
import { assetsToGeoJSON } from '../../hooks/insights/helpers/MapUtils'
import { BackendAsset } from '../../hooks/risks/types/BackendData'

const AppWrapperV2 : FC = () => {
  const {
    loading, view, showSelectedAsset, submittedMessage, setSubmittedMessage, viewMode, focusedAsset,
    showMapFilterPopup, setShowMapFilterPopup, assets, mapRef, allAssets,
  } = useRiskRegister()

  const { workspace, setMapView } = useWorkspace()
  const apiHook = useApi()
  const [selectedMapViewer, setSelectedMapViewer] = React.useState()
  const [selectedMapAssets, setSelectedMapAssets] = useState([])

  const handleDownload = (risk: boolean) => {
    if (risk) {
      apiHook.downloadRisks({
        domain_id: workspace.id,
        asset_id: focusedAsset.id, // changed to focused asset
      })
        .then((data) => {
          downloader(data, 'Risk Register.xlsx')
        })
    } else {
      apiHook.downloadAssets({
        domain_id: workspace.id,
      })
        .then((data) => {
          downloader(data, 'Asset Register.xlsx')
        })
    }
  }

  const handleToggle = (event) => {
    setSelectedMapViewer(event.target.value)
    // Add your function logic here
    setMapView(event.target.value)
  }

  const assetsToPointGeojson = (assets: BackendAsset[]) : turf.FeatureCollection<turf.Point, BackendAsset> => ({
    type: 'FeatureCollection',
    features: assets.map((val) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [
          val.longitude, val.latitude,
        ],
      },
      properties: {
        ...val,
        type: val.asset_type,
      },
    })),
  })

  const customStyles = {
    control: (provided) => ({
      ...provided,
      fontSize: '13px',
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: '13px',
    }),
    option: (provided) => ({
      ...provided,
      fontSize: '13px',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#326771',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff',
      ':hover': {
        backgroundColor: '#ff0000',
        color: '#fff',
      },
    }),
  }

  const applyMapFilters = () => {
    if (!mapRef.current) return

    const pointSource = mapRef.current.getSource('assets-points') as mapboxgl.GeoJSONSource | undefined
    const lineSource = mapRef.current.getSource('assets-lines') as mapboxgl.GeoJSONSource | undefined
    const polygonSource = mapRef.current.getSource('assets-polygons') as mapboxgl.GeoJSONSource | undefined
    if (selectedMapAssets.length > 0) {
      const filteredAssets = allAssets.filter((asset) => selectedMapAssets.some((selected) => selected.value === asset.id))
      const { featureLines, featurePolygons } = assetsToGeoJSON(filteredAssets)
      const pointGeojson = assetsToPointGeojson(filteredAssets)

      pointSource?.setData(pointGeojson)
      lineSource?.setData(featureLines)
      polygonSource?.setData(featurePolygons)
    } else {
      const emptyGeoJSON = {
        type: 'FeatureCollection',
        features: [],
      }
      pointSource?.setData(emptyGeoJSON)
      lineSource?.setData(emptyGeoJSON)
      polygonSource?.setData(emptyGeoJSON)
    }
    setShowMapFilterPopup(false)
  }

  return (
    <ProvideAddAsset>
      <LoadingModal isOpen={loading} />
      <MapControlsV2 />
      <IonRow class='ion-text-end'>
        <IonCol>
          {
            viewMode.view === Views.REGISTER_VIEW && viewMode.listMode === ListModes.RISKS && (
              <IonButton style={{ '---background': '#FFFFFF', '--ion-color-primary': '#FFFFFF' }} onClick={() => handleDownload(true)}>
                <p style={{ margin: '0', fontSize: '12px', color: 'black' }}><Icon icon='vscode-icons:file-type-excel' inline />Download Risk Register</p>
              </IonButton>
            )
          }
        </IonCol>
      </IonRow>
      <RiskRegisterMapV2 />
      {
        view === AppView.ASSET_MAP && showSelectedAsset && (
          <AssetProfileV2 />
        )
      }
      {
        showMapFilterPopup && (
          <>
            <ObscureBackground style={{ zIndex: 20 }} />
            <OverlayContainer style={{ zIndex: 25, width: '35%', height: '65%', borderRadius: '1em', overflowY: 'auto', display: 'flex', flexDirection: 'column' }} className='terrain-add-popup'>
              <IonRow>
                <IonCol size='9'>
                  <h5 style={{ fontSize: 14 }}>Map Filter</h5>
                </IonCol>
                <IonCol size='3' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <SherpaButton style={{ fontSize: '1rem' }} onClick={() => setShowMapFilterPopup(false)}>
                    Close X
                  </SherpaButton>
                </IonCol>
              </IonRow>
              <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
                <IonCol size='4'>
                  <IonLabel style={{ marginRight: '10px', fontSize: 14, color: '#326771' }}>Map Type</IonLabel>
                </IonCol>
                <IonCol size='8'>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label style={{ marginRight: '20px' }}>
                      <input
                        type='radio'
                        value='map'
                        checked={selectedMapViewer === 'map'}
                        onChange={handleToggle}
                        style={{ marginRight: '10px', color: '#326771' }}
                      />
                      Default
                    </label>
                    <label style={{ marginRight: '20px' }}>
                      <input
                        type='radio'
                        value='satellite'
                        checked={selectedMapViewer === 'satellite'}
                        onChange={handleToggle}
                        style={{ marginRight: '10px', color: '#326771' }}
                      />
                      Satellite
                    </label>
                  </div>
                </IonCol>
              </IonRow>
              <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
                <IonCol size='4'>
                  <IonLabel style={{ marginRight: '10px', fontSize: 14, color: '#326771' }}>Key Assets</IonLabel>
                </IonCol>
                <IonCol size='8'>
                  <Select
                    isMulti
                    placeholder='Select Key Asset(s)'
                    name='colors'
                    className='select-container'
                    id='stakeholder-type'
                    options={assets.sort((a, b) => a.name.localeCompare(b.name)).map(({ id, name }) => ({ value: id, label: name }))}
                    value={selectedMapAssets}
                    onChange={(selected) => setSelectedMapAssets(selected)}
                    isCreatable={false}
                    menuPortalTarget={document.body}
                    styles={customStyles}
                  />
                </IonCol>
              </IonRow>
              <IonRow style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto' }}>
                <IonCol>
                  <IonButton onClick={() => setShowMapFilterPopup(false)} style={{ '--background': '#8E151F' }}>
                    Cancel
                  </IonButton>
                </IonCol>
                <IonCol style={{ textAlign: 'right' }}>
                  <IonButton onClick={applyMapFilters} style={{ '--background': '#4197A9' }}>
                    Filter
                  </IonButton>
                </IonCol>
              </IonRow>
            </OverlayContainer>
          </>
        )
      }
      {
        submittedMessage && (
          <>
            <ObscureBackground style={{ zIndex: '10' }} />
            <CenterForm style={{ height: 'auto', width: '30%' }}>
              <FormPopup message={submittedMessage} onClose={() => setSubmittedMessage(null)} />
            </CenterForm>
          </>
        )
      }
    </ProvideAddAsset>

  )
}

export default AppWrapperV2
